import { getHiDpiRatio } from '../../../render-settings';

const STATES = {
  PENDNIG: 'PENDING',
  LOADING: 'LOADING',
  LOADED: 'LOADED'
};

export function makeTile (url) {
  const img = new Image();
  let state = STATES.PENDNIG;
  let request;

  function remove () {
    request && request.abort();
    img.remove();
    state = STATES.PENDNIG;
  }

  function load () {
    if (state === STATES.PENDNIG) {
      request = new XMLHttpRequest();
      request.open('GET', url);
      request.responseType = 'text';
      request.onload = async () => {
        img.src = await getCompensatedDataUrl(url);
        state = STATES.LOADED;
      };
      request.send();
      state = STATES.LOADING;
    }
  }

  return {img, load, remove};
}

// This element is used to scale images from imageserver. To paint it needs to be attached to the DOM, but we don't want
// it to clutter the UI so we size it 0
let canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
canvas.style.maxWidth = canvas.style.maxHeight = canvas.style.padding = canvas.style.margin = canvas.style.border = 0;
document.addEventListener('DOMContentLoaded', () => {
  document.body.appendChild(canvas);
});

// Takes into account the user's scale factor and scales the image retrieved from imageserver as necessary
// to maintain image quality.
function getCompensatedDataUrl (url) {
  return new Promise((resolve, reject) => {
    const scale = getHiDpiRatio(); // returns 1 if no scaling or if hidpi compensation is disabled
    // There's a performance hit associated with this technique, so don't use it unless we have to
    // to maintain image quality.
    if (scale === 1) {
      resolve(url);
    }

    const sourceImage = new Image();
    sourceImage.addEventListener('load', render);
    sourceImage.src = url;

    function render () {
      canvas.height = sourceImage.height * scale;
      canvas.width = sourceImage.width * scale;
      ctx.imageSmoothingEnabled = false;
      ctx.scale(scale, scale);
      ctx.drawImage(sourceImage, 0, 0);

      resolve(canvas.toDataURL());
    }
  });
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/services/rendering/tile.js